import { useEffect, useState, KeyboardEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useForm } from 'react-hook-form'
import {
  fetchAtivaDesativaOrganizacao,
  getOrganizationListAll,
} from '../../services/Organizations/getOrganizations'
import { IFormInputs } from '../NewUsers/NewUser.interface'

type OrganizacaoLista = {
  ativo: boolean
  id: number
  nome: string
  tenantId: string
  // Vai no state de navegação para a tela de detalhe, que não refaz o GET.
  chatSuporteAtivo?: boolean
}

export const useOrganizacoesAdmin = () => {
  const navigate = useNavigate()
  const { control } = useForm<IFormInputs>({
    mode: 'onChange',
    defaultValues: {
      isAdmin: false,
    },
  })

  const [searchValue, setSearchValue] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)
  const [status, setStatus] = useState(Boolean)
  const [organizacaoId, setOrganizacaoId] = useState<number>(0)
  const [inativaOrganizacao, setInativaOrganizacao] = useState(false)

  const [useOrganizationsListAll, setUseOrganizationListAll] =
    useState<GetOrganizationsListAllType>({} as GetOrganizationsListAllType)

  const fetchOrganizationListAll = async () => {
    setIsLoading(true)
    const result = await getOrganizationListAll(searchValue, currentPage)
    setIsLoading(false)
    if ('message' in result) {
      if (result.message === 'Usuário não autenticado') {
        window.location.href = '/logout'
      } else {
        toast.error(result.message)
      }
    } else {
      setUseOrganizationListAll(result)
    }
  }

  const ativaDesativaOrganizacao = async (acao: string) => {
    setIsLoading(true)
    const result = await fetchAtivaDesativaOrganizacao(organizacaoId, acao)
    setIsLoading(false)
    if ('info' in result) {
      toast.success(result.info)
      fetchOrganizationListAll()
      return
    }
    if ('message' in result) {
      toast.error(result.message)
    }
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      fetchOrganizationListAll()
    }
  }

  const desativar = () => ativaDesativaOrganizacao('desativar')
  const ativar = () => ativaDesativaOrganizacao('ativar')
  const fechaInativaOrganizacao = () => setInativaOrganizacao(false)

  const irParaNovaOrganizacao = () => navigate('/adm-organizacao/novo')
  const irParaEditarOrganizacao = (organizacao: OrganizacaoLista) =>
    navigate(`/adm-organizacao/${organizacao.id}`, { state: { organizacao } })

  useEffect(() => {
    fetchOrganizationListAll()
  }, [currentPage])

  return {
    searchValue,
    setSearchValue,
    currentPage,
    setCurrentPage,
    fetchOrganizationListAll,
    isLoading,
    handleKeyDown,
    control,
    useOrganizationsListAll,

    inativaOrganizacao,
    setInativaOrganizacao,
    fechaInativaOrganizacao,
    ativar,
    desativar,
    status,
    setStatus,
    setOrganizacaoId,

    irParaNovaOrganizacao,
    irParaEditarOrganizacao,
  }
}
